export abstract class AppConfig {
  version: string;
  production: boolean;
  adminServer: string;
  reportsServer: string;
  mfaPhonePreValidation: boolean;
  legacyForwardUrl: string;
}
